module.exports = __webpack_public_path__ + "img/dyson-sphere-component.c8bdce69.png";